export const defaultScrollInit = () => {
  document
    .querySelectorAll(".js-scroll-into-view")
    .forEach(initScrolledIntoView);
};

export const isScrolledIntoView = (el, all = false) => {
  const rect = el.getBoundingClientRect();
  const elemTop = rect.top;
  const elemBottom = rect.bottom;

  if (all) {
    // Only completely visible elements return true:
    return elemTop <= 0 && elemBottom > window.innerHeight;
  } else {
    // Partially visible elements return true:
    return (
      elemTop <= window.innerHeight / 2 + 100 &&
      elemBottom > window.innerHeight / 2 - 100
    );
  }
};

export const initScrolledIntoView = (el) => {
  const scrollAll =
    (el.dataset.scrollAll && el.dataset.scrollAll === "true") || false;

  const repeatAnimation = el.dataset?.repeatAnimation === "true" || false;

  const enterPageObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("scrolled-into-view");

          if (!repeatAnimation) {
            enterPageObserver.unobserve(el);
          }
        } else {
          entry.target.classList.remove("scrolled-into-view");
        }
      });
    },
    {
      root: null,
      rootMargin: "0px 0px -50%",
      threshold: scrollAll ? 1 : 0,
    },
  );

  enterPageObserver.observe(el);
};
